import React, { useEffect, useState } from "react";
import Loader from "../global/Loader";
import DataTable from "../datatable/DataTable";
import { withdrawals } from "../../constants/data";
import CurrencyFormatter from "../global/CurrencyFormatter";
import DateTimeFormat from "../global/DateTimeFormat";
import { withdrawal_commissions_unregistered } from "../../constants/Tariffs";
import HeaderInfo from "./HeaderInfo";

function Withdrawals() {
  const headers = [
    "Transaction ID",
    "Client",
    "Client ID",
    "Amount",
    "Commission",
    "Type",
    "Date",
  ];
  let tableRows = [];

  let commission = 0;

  if (withdrawals.length) {
    for (let i = 0; i < withdrawals.length; i++) {
      const commissionEarned =
        withdrawals[i].type > 1
          ? withdrawal_commissions_unregistered(withdrawals[i].amount_withdrawn)
          : withdrawal_commissions_unregistered(
              withdrawals[i].amount_withdrawn
            );
      commission = commission += commissionEarned;
      tableRows.push({
        withdrawal_id: withdrawals[i].withdrawal_id,
        client_name: withdrawals[i].client_name,
        client_id: withdrawals[i].client_id_number,
        amount_withdrawn: (
          <CurrencyFormatter value={withdrawals[i].amount_withdrawn} />
        ),
        commision: <CurrencyFormatter value={commissionEarned} />,
        type: withdrawals[i].type > 1 ? "Unregistered user" : "Registered user",
        created_at: (
          <DateTimeFormat>{withdrawals[i].created_at}</DateTimeFormat>
        ),
      });
    }
  }

  // fetching data
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());

  useEffect(() => {
    handleAction(selectedMonth);
  }, [selectedMonth]);

  let handleAction = (val) => {
    console.log(val);
  };

  const displayContent = withdrawals ? (
    !withdrawals.length ? (
      <Loader />
    ) : (
      <DataTable headers={headers} data={tableRows} />
    )
  ) : (
    <Loader />
  );

  return (
    <div>
      {/* header information */}
      <HeaderInfo commission={commission} action={setSelectedMonth} />
      {displayContent}
    </div>
  );
}

export default Withdrawals;
